import React from 'react';
import { motion } from 'framer-motion';
import { ThumbsUp, MessageCircle, Share2, MoreHorizontal } from 'lucide-react';
const comments = [{
  name: 'María González',
  text: '¡Los prompts son oro puro! En 2 días ya tenía mi PDF listo 🙌',
  hasReply: true,
  reply: {
    name: 'Ana Rodríguez',
    text: '¿En serio? Yo llevo meses pensándolo...'
  }
}, {
  name: 'Carmen Flores',
  text: 'La IA hizo todo el trabajo, yo solo revisé. Increíble 😍'
}, {
  name: 'Lucía Martínez',
  text: 'Pensé que era complicado pero los prompts maestros lo hacen súper fácil'
}, {
  name: 'Isabel Torres',
  text: 'Ya vendí 3 PDFs gracias a este sistema! 💰',
  hasReply: true,
  reply: {
    name: 'Patricia Ruiz',
    text: '¡Wow! ¿Cuánto tiempo te tomó?'
  }
}, {
  name: 'Rosa Sánchez',
  text: 'Lo mejor es que no necesitas mostrar tu cara, perfecto para mí'
}, {
  name: 'Elena Ramírez',
  text: 'Los guiones de Instagram que incluye son perfectos 👌'
}, {
  name: 'Sofía Morales',
  text: 'En una semana pasé de cero a tener mi producto listo'
}, {
  name: 'Andrea Castro',
  text: 'La IA escribió mejor de lo que yo hubiera escrito 😂'
}, {
  name: 'Gabriela Ortiz',
  text: 'Vale cada centavo, es una inversión que se paga sola'
}, {
  name: 'Valentina Díaz',
  text: 'Los prompts son tan buenos que la IA entiende exactamente qué hacer'
}, {
  name: 'Daniela Vargas',
  text: 'Yo que pensaba que necesitaba ser experta... la IA hace todo!'
}, {
  name: 'Carolina Méndez',
  text: 'El diseño quedó profesional sin usar Canva ni nada complicado'
}, {
  name: 'Fernanda Silva',
  text: 'Mis amigas no creen que lo hice en 7 días 🤭'
}, {
  name: 'Camila Herrera',
  text: 'La biblioteca de prompts vale más que el precio completo'
}, {
  name: 'Natalia Jiménez',
  text: 'Finalmente un sistema que entiende que tenemos hijos y poco tiempo'
}, {
  name: 'Paula Gutiérrez',
  text: 'Ya recuperé mi inversión con la primera venta 🎉'
}, {
  name: 'Alejandra Rojas',
  text: 'La guía faceless es perfecta, no tengo que aparecer en video'
}];
export function FacebookWall() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-13">
      <div className="max-w-2xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-15">
          {/* Post Header */}
          <div className="p-4 border-b border-border" data-id="element-16">
            <div className="flex items-center gap-3" data-id="element-17">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-bold" data-id="element-18">
                MI
              </div>
              <div data-id="element-19">
                <h3 className="font-semibold text-dark" data-id="element-20">Sistema Mamá IA</h3>
                <p className="text-xs text-body" data-id="element-21">Hace 2 horas · 🌎</p>
              </div>
              <button className="ml-auto text-body" data-id="element-22">
                <MoreHorizontal className="w-5 h-5" data-id="element-23" />
              </button>
            </div>
          </div>

          {/* Post Content */}
          <div className="p-4" data-id="element-24">
            <p className="text-dark mb-4" data-id="element-25">
              ¿Quién ya usó la IA para crear su producto? 🙌
            </p>
          </div>

          {/* Post Image */}
          <div className="w-full" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/wnbnuNv6h2pFtQgk96D1ok/portada_(1).webp" alt="Sistema Mamá IA - Portada del Producto" className="w-full" data-id="element-27" />
          </div>

          {/* Post Stats */}
          <div className="px-4 py-3 border-b border-border" data-id="element-28">
            <div className="flex items-center justify-between text-sm text-body" data-id="element-29">
              <div className="flex items-center gap-1" data-id="element-30">
                <div className="w-5 h-5 bg-primary rounded-full flex items-center justify-center" data-id="element-31">
                  <ThumbsUp className="w-3 h-3 text-white" data-id="element-32" />
                </div>
                <span data-id="element-33">847</span>
              </div>
              <div className="flex gap-4" data-id="element-34">
                <span data-id="element-35">234 comentarios</span>
                <span data-id="element-36">89 compartidos</span>
              </div>
            </div>
          </div>

          {/* Post Actions */}
          <div className="px-4 py-2 border-b border-border" data-id="element-37">
            <div className="flex items-center justify-around" data-id="element-38">
              <button className="flex items-center gap-2 py-2 px-4 text-body hover:bg-gray-50 rounded-lg transition-colors" data-id="element-39">
                <ThumbsUp className="w-5 h-5" data-id="element-40" />
                <span className="font-semibold" data-id="element-41">Me gusta</span>
              </button>
              <button className="flex items-center gap-2 py-2 px-4 text-body hover:bg-gray-50 rounded-lg transition-colors" data-id="element-42">
                <MessageCircle className="w-5 h-5" data-id="element-43" />
                <span className="font-semibold" data-id="element-44">Comentar</span>
              </button>
              <button className="flex items-center gap-2 py-2 px-4 text-body hover:bg-gray-50 rounded-lg transition-colors" data-id="element-45">
                <Share2 className="w-5 h-5" data-id="element-46" />
                <span className="font-semibold" data-id="element-47">Compartir</span>
              </button>
            </div>
          </div>

          {/* Comments */}
          <div className="p-4 max-h-96 overflow-y-auto" data-id="element-48">
            {comments.map((comment, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="mb-4" data-id="element-49">
                <div className="flex gap-2" data-id="element-50">
                  <div className="w-8 h-8 bg-gray-300 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-semibold text-white" data-id="element-51">
                    {comment.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div className="flex-1" data-id="element-52">
                    <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-53">
                      <p className="font-semibold text-sm text-dark" data-id="element-54">
                        {comment.name}
                      </p>
                      <p className="text-sm text-dark" data-id="element-55">{comment.text}</p>
                    </div>
                    {comment.hasReply && comment.reply && <div className="ml-8 mt-2 flex gap-2" data-id="element-56">
                        <div className="w-7 h-7 bg-gray-300 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-semibold text-white" data-id="element-57">
                          {comment.reply.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div className="flex-1" data-id="element-58">
                          <div className="bg-gray-100 rounded-2xl px-3 py-2" data-id="element-59">
                            <p className="font-semibold text-xs text-dark" data-id="element-60">
                              {comment.reply.name}
                            </p>
                            <p className="text-xs text-dark" data-id="element-61">
                              {comment.reply.text}
                            </p>
                          </div>
                        </div>
                      </div>}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}